






























import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  props: {
    datosInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    openDialog: false,
    datos: [],
  }),
  methods: {
    async EliminarUnidades() {
      this.loading = true;
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      for (const unit of this.datos) {
        try {
          const datos = {admin, condo, unidad: unit };
          console.debug('datos: %o', datos);
          const result = await this.$store.dispatch('deleteUnidad', datos );
          console.debug('EliminarUnidades: %o', result);
          this.$toast.success('Unidad borrada');
        } catch (e) {
          this.$toast.error(e.response.data.message);
        }
      }
      this.openDialog = false;
      this.$emit('reload', {});
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        this.datos = Array.from(this.datosInit);
      } else {
        this.datos = Array.from([]);
      }
    },
  },
});
